function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(5.903)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(1.312)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0.324)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M392,475.653a.492.492,0,0,1-.348-.839l9.182-9.182a.492.492,0,0,1,.7.7l-9.182,9.182A.49.49,0,0,1,392,475.653Z",
  transform: "translate(-391.513 -465.487)"
}),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(2.295 2.295)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M399,482.653a.492.492,0,0,1-.348-.839l9.182-9.182a.492.492,0,0,1,.7.7l-9.182,9.182A.49.49,0,0,1,399,482.653Z",
  transform: "translate(-398.513 -472.487)"
}))),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(9.182)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M422.3,468.1a.491.491,0,0,1-.371-.815,1.27,1.27,0,0,0-.09-1.5,1.108,1.108,0,0,0-.781-.3,1.1,1.1,0,0,0-.715.187.492.492,0,0,1-.679-.712,1.992,1.992,0,0,1,1.422-.458,2.061,2.061,0,0,1,1.47.612,2.242,2.242,0,0,1,.113,2.821A.491.491,0,0,1,422.3,468.1Z",
  transform: "translate(-419.513 -464.499)"
}))),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 9.506)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M388,498.078a.492.492,0,0,1-.462-.66l1.312-3.607a.492.492,0,1,1,.924.336l-.951,2.617,2.617-.951a.492.492,0,0,1,.336.924l-3.607,1.312A.491.491,0,0,1,388,498.078Z",
  transform: "translate(-387.512 -493.487)"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 2.62)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M386.4,489.867H370a.492.492,0,0,1-.492-.492v-16.4a.492.492,0,0,1,.492-.492H380.5a.492.492,0,1,1,0,.984h-10v15.412h15.413v-10a.492.492,0,0,1,.984,0v10.489a.492.492,0,0,1-.492.492Z",
  transform: "translate(-369.512 -472.487)"
})));

var SvgNewNote = function SvgNewNote(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgNewNote, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/NewNote.29a47323.svg";
export { ForwardRef as ReactComponent };